import { createSlice } from '@reduxjs/toolkit';

export const modalSlice = createSlice({
    name: 'modal',
    initialState: {
        currentModalIndex: 0,
        modalIds: [],
        modalData: [],
    },
    reducers: {
        openModals: (state, {payload}) => {
            if (!payload) {
                return state;
            }
            state.modalIds = payload.modalIds;
            state.modalData = payload.modalData || [];
        },
        closeModal: (state ) => {
            return {
                ...state,
                currentModalIndex: 0,
                modalIds: [],
                modalData: [],
            };
        },
    },
});

export const {
    openModals,
    closeModal,
} = modalSlice.actions;

export default modalSlice.reducer;
